import { Address, formatAddress, isAddress, Port, PortOrAddress } from 'features/Directory'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { IQuoteOption } from '../QuoteSheetOption'
import { LCLMainRate } from '../Rate/LCLRate'
import { Description } from './Description'
import { useDescriptionStyles } from './Descriptions'
import { isOptionWithPOD, isOptionWithViaPortId, TransportProps } from './QuoteTransportPlan'

const getOptionPOD = (option: IQuoteOption): Port | null => {
  return isOptionWithPOD(option) ? (option.routeQuotes.mainQuote.route.journey.destination as Port) : null
}

export const LCLDescriptions: FC<TransportProps> = ({ quoteSheet, option }) => {
  const { translate } = useI18n()
  const classes = useDescriptionStyles()

  const formatPortOrAddress = (point: PortOrAddress): string => {
    return isAddress(point) ? formatAddress(point) : `${point._id} - ${point.name}`
  }

  const mainRate = option.routeQuotes.mainQuote.rates ? (option.routeQuotes.mainQuote.rates[0] as LCLMainRate) : null
  const { origin } = option.routeQuotes.mainQuote.route.journey

  const originLabel =
    option.mode === 'air' && !isAddress(origin)
      ? translate('quote_sheet-option-transport_plan-departure_airport')
      : translate('quote_sheet-option-transport_plan-origin')

  // Origin can be null when creating manual quotes
  const originName = origin ? formatPortOrAddress(origin) : ''

  // @ts-expect-error TS(2322) FIXME: Type 'Port | null' is not assignable to type 'Port... Remove this comment to see the full error message
  const pod: Port = getOptionPOD(option)
  const PODLabel = pod
    ? option.mode === 'air' || option.mode === 'seaAir'
      ? translate('quote_sheet-option-transport_plan-arrival_airport')
      : translate('quote_sheet-option-transport_plan-POD')
    : ''

  return (
    <div className={classes.descriptions}>
      <Description label={originLabel} text={originName} />
      {option.mode === 'seaAir' && mainRate && isOptionWithViaPortId(option) && (
        <Description
          label={translate('quote_sheet-option-transport_plan-sea_air_via')}
          text={mainRate.via_ids ? mainRate.via_ids.join(' ') : ''} // TODO name
        />
      )}

      {pod && <Description label={PODLabel} text={`${pod._id} - ${pod.name}`} />}
      <Description
        label={translate('quote_sheet-option-transport_plan-destination')}
        text={(quoteSheet.request.journey.destination as Address).city}
        // we don't show delivery note for LCL
        // as we do not provide an ETA before booking for LCL
        // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
        note={null}
      />
    </div>
  )
}
